import React from 'react'
import { Link } from 'react-router-dom'


const ClickHandler = () => {
    window.scrollTo(10, 0);
}


const BusinessFooter = (props) => {
    return (
        <footer className="site_footer footer_layout_3">
        <div className="footer_main_content">
          <div className="container">
            <div className="row mb-5">
              <div className="col-lg-4">
                <div className="heading_block mb-lg-0 text-white">
                  <h2 className="heading_text mb-1">
                    Digi Pexel
                  </h2>
                  <p className="heading_description mb-0">
                   Digi Pexel has solutions to help your business grow online. Join the league of 58 smart agencies that outsource to us.
                  </p>
                </div>
              </div>
              <div className="col-lg-8">
                <div className='row'>
                  <div className='col-md-3'>
                      <div className="footer_widget">
                        <h3 className="footer_info_title">Useful Links</h3>
                        <ul className="icon_list unordered_list_block">
                          <li>
                            <Link onClick={ClickHandler} to="/">
                              <span className="icon_list_text">
                                Services
                              </span>
                            </Link>
                          </li>
                          <li>
                            <Link onClick={ClickHandler} to="/">
                              <span className="icon_list_text">
                                About Us
                              </span>
                            </Link>
                          </li>
                          <li>
                            <Link onClick={ClickHandler} to="/">
                              <span className="icon_list_text">
                                Contact Us
                              </span>
                            </Link>
                          </li>
                          <li>
                            <Link onClick={ClickHandler} to="/portfolio">
                              <span className="icon_list_text">
                                Testimonials
                              </span>
                            </Link>
                          </li>
                        </ul>
                      </div>
                  </div>
                  <div className='col-md-3'>
                      <div className="footer_widget">
                        <h3 className="footer_info_title">Useful Links</h3>
                        <ul className="icon_list unordered_list_block">
                          <li>
                            <Link onClick={ClickHandler} to="/">
                              <span className="icon_list_text">
                                Services
                              </span>
                            </Link>
                          </li>
                          <li>
                            <Link onClick={ClickHandler} to="/">
                              <span className="icon_list_text">
                                About Us
                              </span>
                            </Link>
                          </li>
                          <li>
                            <Link onClick={ClickHandler} to="/">
                              <span className="icon_list_text">
                                Contact Us
                              </span>
                            </Link>
                          </li>
                          <li>
                            <Link onClick={ClickHandler} to="/portfolio">
                              <span className="icon_list_text">
                                Testimonials
                              </span>
                            </Link>
                          </li>
                        </ul>
                      </div>
                  </div>

                  <div className='col-md-3'>
                      <div className="footer_widget">
                        <h3 className="footer_info_title">Useful Links</h3>
                        <ul className="icon_list unordered_list_block">
                          <li>
                            <Link onClick={ClickHandler} to="/">
                              <span className="icon_list_text">
                                Services
                              </span>
                            </Link>
                          </li>
                          <li>
                            <Link onClick={ClickHandler} to="/">
                              <span className="icon_list_text">
                                About Us
                              </span>
                            </Link>
                          </li>
                          <li>
                            <Link onClick={ClickHandler} to="/">
                              <span className="icon_list_text">
                                Contact Us
                              </span>
                            </Link>
                          </li>
                          <li>
                            <Link onClick={ClickHandler} to="/portfolio">
                              <span className="icon_list_text">
                                Testimonials
                              </span>
                            </Link>
                          </li>
                        </ul>
                      </div>
                  </div>


                  <div className='col-md-3'>
                      <div className="footer_widget">
                        <h3 className="footer_info_title">Follow Us</h3>
                        <ul className="social_icons_block unordered_list">
                          <li>
                            <Link onClick={ClickHandler} to="/home_business_consulting">
                              <i className="fa-brands fa-facebook-f"></i>
                            </Link>
                          </li>
                          <li>
                            <Link onClick={ClickHandler} to="/home_business_consulting">
                              <i className="fa-brands fa-twitter"></i>
                            </Link>
                          </li>
                          <li>
                            <Link onClick={ClickHandler} to="/home_business_consulting">
                              <i className="fa-brands fa-linkedin-in"></i>
                            </Link>
                          </li>
                          <li>
                            <Link onClick={ClickHandler} to="/home_business_consulting">
                              <i className="fa-brands fa-youtube"></i>
                            </Link>
                          </li>
                        </ul>
                      </div>
                  </div>



                </div>
                
              </div>
            </div>

            <div className="footer_bottom text-white">
              <p className="copyright_text m-0 text-center">
                  © Digi Pexel 2025. All rights reserved.
                </p>
            </div>
            
          </div>
        </div>
       
      </footer>
    )
}

export default BusinessFooter;